<template>
  <div>Új Email cím megerősítése</div>
</template>

<script>
/* eslint-disable */
import config from '@/config'
import utils from '@/utils'
import notify from '@/notify'

export default {
  created: function () {
    let query = this.$route.query
    if (query.hasOwnProperty('t') && query.hasOwnProperty('u')) {
      let token = query.t
      let userID = query.u

      this.$http({
        url: config.SERVER_DOMAIN + '/api/global/confirm_changed_email',
        method: 'POST',
        params: { userID: userID, changeEmailToken: token },
      }).then(response => {
        console.log('--- email confirmation success')
        // eslint-disable-next-line
        notify.success(response.body.msg || 'Email módosítás sikeres')
      }, error => {
        utils.httpError(error)
        console.log(error)
      }).finally(() => {
        this.$router.push('Reservation')
      })
    } else {
      notify.warning('Hibás email hitelesítési link!')
      // this.$router.push('Reservation')
    }
  },
}
</script>

<style scoped>

</style>
